// Copyright 2026. WebPros International GmbH. All rights reserved.

/**
 * Rewrites the host of a documentation code sample to the one the panel is served from.
 *
 * Samples are baked into the OpenAPI docs when the image is built, so they carry the build
 * container's host instead of the deployment's one. The API URL they are rewritten to already
 * ends with the API prefix in production builds but not in development ones, hence the
 * normalization — otherwise the prefix ends up duplicated.
 */
export const rewriteCodeSampleUrl = (source: string, apiUrl = ''): string => {
    const baseUrl = apiUrl.replace(/\/+$/, '').replace(/\/api\/v1$/, '');

    return source.replace(/https?:\/\/[^\s]+\/api\/v1/, `${baseUrl}/api/v1`);
};
